.tableContainer {
  width: 100%;
  border-radius: 12px;
  background-color: var(--bc-color-bg-container);
  position: relative;

  .pagination {
    padding: 0 16px;
    text-align: right;
  }
}

.tableRoot {
  position: relative; // to apply z-index
  z-index: 1;
}

.settingButton {
  position: absolute;
  top: 8px;
  right: 20px;
  // calc(var(--columns-count, 0) * 2 + 2 + 1) is set on sticky table header, so using the same z-index as tableRoot
  z-index: 1;

  button {
    font-size: 18px;
    line-height: 1;
  }
}

// Removes the expanded row cell padding and the antd nested-table offsets (margins,
// container border, radius), so a table rendered via `expandedRowRender` spans exactly
// the parent columns. Combine with mirrored column widths and `tableLayout="fixed"`
// on both tables to get pixel-perfect column alignment.
// !important is required throughout: antd table rules carry (0,5,0)+ specificity
// (only the hash class is wrapped in :where), so plain module classes lose to them.
.expandedRow {
  // Expanded row cell as a bare container: its content spans exactly the parent columns.
  &:global(.ant-table-expanded-row) > td {
    padding: 0 !important;
  }

  // Neutralize the antd nested-table rule (.ant-table-wrapper:only-child .ant-table):
  // it offsets the nested table by the static tableExpandColumnWidth token, which never
  // matches the actual column grid when tableLayout="fixed" stretches the columns.
  :global(.ant-table) {
    margin: 0 !important;
    border-radius: 0;
  }

  // The bordered-table container border would shift the nested grid by 1px.
  :global(.ant-table-container) {
    border-inline-start: none !important;
    border-radius: 0;
    border-top: none !important;
  }
}
